/** @file PadletAttachmentShape schema */
import { createShapePropsMigrationIds, createShapePropsMigrationSequence, T, TLBaseShape } from 'tldraw'

const padletAttachmentShapeProps = {
  w: T.number,
  h: T.number,
  zoom: T.number,
  resizable: T.boolean,
  postId: T.number,
  isPoll: T.boolean,
}

interface PadletAttachmentShapeProps {
  w: number
  h: number
  zoom: number
  resizable: boolean
  postId: number
  isPoll: boolean
}

type PadletAttachmentShape = TLBaseShape<'padlet-attachment-shape', PadletAttachmentShapeProps>

const versions = createShapePropsMigrationIds('padlet-attachment-shape', {
  AddUploadKeyProp: 1,
  RemoveUploadKeyProp: 2,
  AddZoomProp: 3,
})

const padletAttachmentShapeMigrations = createShapePropsMigrationSequence({
  sequence: [
    {
      id: versions.AddUploadKeyProp,
      up: (props) => {
        // No-op, uploadKey is optional so we don't need to do anything
      },
      down: (props) => {
        if (props.uploadKey != null) {
          delete props.uploadKey
        }
      },
    },
    // We migrated this to meta.uploadKey instead
    {
      id: versions.RemoveUploadKeyProp,
      up: (props) => {
        if (props.uploadKey != null) {
          delete props.uploadKey
        }
      },
      down: (props) => {
        // No-op, uploadKey is optional so we don't need to do anything
      },
    },
    {
      id: versions.AddZoomProp,
      up: (props) => {
        props.zoom = 1
      },
      down: (props) => {
        delete props.zoom
      },
    },
  ],
})

export {
  PadletAttachmentShape,
  padletAttachmentShapeMigrations,
  PadletAttachmentShapeProps,
  padletAttachmentShapeProps,
  versions,
}
